<script>
  import Multiselect from 'vue-multiselect'
  import { saleRepTypesMethods } from '@state/helpers'

  export default {
    components: {
      Multiselect,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        default: null,
      },
    },
    data() {
      return {
        saleReps: [],
        model: this.value,
      }
    },
    watch: {
      model (val) {
        this.$emit('change', val)
      },
    },
    async created() {
      const { data } = await this.getListSaleRepTypes()
      this.saleReps = data.data
    },
    methods: {
      ...saleRepTypesMethods,
      addSaleRepType(type, index) {
        this.saleReps.push({ name: type });
        this.model.push({ name: type });
      },
    }
  }
</script>

<template>
  <Multiselect
    v-model="model"
    :multiple="true"
    :class="{
      'scrollable': (saleReps || []).length > 7,
    }"
    :options="saleReps || []"
    :taggable="true"
    label="name"
    track-by="name"
    @tag="addSaleRepType"
  />
</template>
